var t = function t(e) {
  return e ? "A" === e.tagName ? e : t(e.parentElement) : null;
},
    e = function e(t) {
  return -1 !== t.href.indexOf(location.protocol + "//" + location.host) ? t.href.split(location.host, 2)[1] : null;
};

module.exports = function (n) {
  return function (r) {
    if (!(0 !== r.button || r.ctrlKey || r.shiftKey || r.altKey || r.metaKey)) {
      var o = t(r.target);

      if (o && "_blank" !== o.target && "_external" !== o.target && !o.hasAttribute("download")) {
        var a = e(o);
        a && (r.preventDefault(), n(a));
      }
    }
  };
};